export class ResponseModel{
  constructor(
      public error: string,
      public mensaje: string
  ){}

  static clone(obj: ResponseModel){
      return new ResponseModel(obj.error,obj.mensaje);
  }

  static fromJson(obj: any){
      return new ResponseModel(obj.error,obj.mensaje);
  }

  static new(){
      return new ResponseModel('','');
  }
}
